import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BrandService {


  url = environment.serverAPI5 + "/api/brand";

  constructor(private http: HttpClient) { }

  getAllBrand(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllBrandDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getBrandById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditbrand(brand: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, brand);
  }

  brandSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }
  deleteByBrandsModelId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }
  downloadBrandsTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }
  downloadBrandsReport(Page: number, size: number, sort, selectionBrands): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
    &size=${size}&sort=${sort}`, selectionBrands, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

}
